export default "__VITE_PUBLIC_ASSET__0e9176bc__"